// import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadPutAwayRules = async () => {
  try {
    const response = await Axios.get('putawayrules');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

export const loadProductPutawayrule = async (action) => {
  try {
    const response = await Axios.get('putawayrules/product/'+action);
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

const loadOneAttribute = async (name) => {
  try {
    const respnse = await Axios.get('putawayrules/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadAttribute = async (action) => {
  try {
    switch (action) {
      case 'new':
        // const response = await Axios.get('setups/product-categories');
        // const responseData = await response.data;
        // return {...responseData, category: {}};
        return {};
        
      default:
        const data = await loadOneAttribute(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const usePutAwayRules = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('putawayrules', data);
      const responseData = await respnse.data;
      success(responseData.message);
    //   EventEmitter.dispatch('reordering_response');
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('putawayrules/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
    //   EventEmitter.dispatch('reordering_response', data.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default usePutAwayRules;


